module.exports = __webpack_public_path__ + "static/media/icon-save.b5982755.svg";